// LaunchDarkly configuration constants
export const LAUNCHDARKLY_CLIENT_ID =
  import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID || "";

/**
 * Context key used for logged-out visitors. Must stay identical between the
 * LDProvider bootstrap context (App.tsx) and identity-sensitive flag readers
 * (e.g. useStandaloneFetalSexRollout), which compare against it to decide
 * whether the client is evaluating the identity they render for.
 */
export const ANONYMOUS_LD_CONTEXT_KEY = "anonymous";

export enum FeatureFlags {
  PatientPortalChatbot = "patientPortalChatbot",
  IsAggressiveChatbot = "isAggressiveChatbot",
  PatientNpsFeedback = "patientNpsFeedback",
  PatientPortalSpanishLanguageToggle = "patientPortalSpanishLanguageToggle",
  PortalStatus = "portalStatus",
  Cfc = "patientCfc",
  PartialResultsBanner = "partialResultsBanner",
  PatientResultsTracker = "patientResultsTracker",
  CarrierResultVideos = "patientCarrierResultVideos",
  PatientPhlebotomySearch = "patientPhlebotomySearch",
  PatientPhlebotomySalesforceFinder = "patientPhlebotomySalesforceFinder",
  PatientPhlebotomyGetLabsSandbox = "patientPhlebotomyGetLabsSandbox",
  PatientStandaloneFetalSex = "patientStandaloneFetalSex",
}
